import useSWR, { ConfigInterface, keyInterface } from 'swr';

import api from '@services/api';

export function useFetch<Data = any, Error = any>(
  url: keyInterface,
  config: ConfigInterface<Data, Error> = {}
) {
  const { data, error, mutate, isValidating, revalidate } = useSWR<Data, Error>(
    url,
    async urlRequest => {
      const response = await api.get(urlRequest);
      return response.data;
    },
    {
      ...config,
      onErrorRetry: (
        errorRetry,
        key,
        option,
        errorRevalidate,
        { retryCount = 0 }
      ) => {
        if (errorRetry?.response?.status === 401) return;

        setTimeout(() => errorRevalidate({ retryCount: retryCount + 1 }), 5000);
      }
    }
  );

  const loading = !data && !error;

  return { data, error, mutate, isValidating, revalidate, loading };
}
